"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFB = exports.redirectToDialog = exports.isRedirected = exports.DIALOG_PARAMS_STATE = void 0;
var params_1 = require("./params");
exports.DIALOG_PARAMS_STATE = "fb-login-state";
function isRedirected(dialogParams) {
    var _a, _b;
    var params = (0, params_1.decodeUlrParamsToObject)(window.location.search);
    return (((_a = params.state === (dialogParams === null || dialogParams === void 0 ? void 0 : dialogParams.state)) !== null && _a !== void 0 ? _a : exports.DIALOG_PARAMS_STATE) &&
        params[(_b = dialogParams === null || dialogParams === void 0 ? void 0 : dialogParams.response_type) !== null && _b !== void 0 ? _b : ""] !== undefined);
}
exports.isRedirected = isRedirected;
function redirectToDialog(dialogParams, loginOptions) {
    window.location.href = "https://www.facebook.com/dialog/oauth".concat((0, params_1.encodeObjectToUlrParams)(__assign(__assign({}, dialogParams), loginOptions)));
}
exports.redirectToDialog = redirectToDialog;
function getFB() {
    if (!window.FB) {
        throw new Error("window.FB SDK not available");
    }
    return window.FB;
}
exports.getFB = getFB;
